<template>
  <div>
    <!-- 侧边栏整体 -->
    <div class="sidebar">
      <div class="logo">
        <img src="@/assets/scheme/logo.svg" alt="logo" />
      </div>
      <div class="side-menu">
        <div class="menu-list">
          <div
            v-for="(item, idx) in currentNav.menuList"
            :key="item.key"
            class="menu-item"
            :class="{ active: activeMenu === item.key }"
            @click="handleMenuClick(item.key, idx)"
          >
            {{ item.label }}
          </div>
        </div>
      </div>
    </div>
    <!-- 导航 -->
    <div class="scheme-container">
      <div class="nav-wrapper">
        <div
          v-for="item in navList"
          :key="item.key"
          class="nav-item"
          :class="{ active: activeItem === item.key }"
          @click="handleNavClick(item.key)"
        >
          <span>{{ item.label }}</span>
        </div>
      </div>
    </div>
    <!-- 图片 -->
    <div class="image-wrapper" ref="imageWrapper">
      <img
        style="min-width: 1500px; max-width: 1900px; width: 100%"
        :src="currentNav.img"
        :alt="currentNav.label"
        class="image"
        v-if="currentNav.img"
      />
      <div v-if="currentExtraImages.images.length" class="extra-images">
        <img
          style="min-width: 1500px; max-width: 1900px; width: 100%"
          v-for="(img, idx) in currentExtraImages.images"
          :key="idx"
          :id="currentExtraImages.prefix + (idx + 1)"
          :src="img"
          class="image"
          :alt="currentExtraImages.altPrefix + (idx + 1)"
        />
      </div>
    </div>
    <!-- 回到顶部按钮 -->
    <transition name="fade-bottom">
      <button
        v-if="showBackToTop"
        class="back-to-top"
        @click="scrollToTop"
        aria-label="回到顶部"
      >
        ↑
      </button>
    </transition>
  </div>
</template>

<script>
import { nextTick } from "vue";
export default {
  data() {
    return {
      navList: [
        {
          key: "environmentalMonitoring",
          label: "动环监控系统DCMS",
          img: require("@/assets/scheme/dcms.png"),
          img01: require("@/assets/scheme/dcms01.png"),
          img02: require("@/assets/scheme/dcms02.png"),
          img03: require("@/assets/scheme/dcms03.png"),
          img04: require("@/assets/scheme/dcms04.png"),
          img05: require("@/assets/scheme/dcms05.png"),
          img06: require("@/assets/scheme/dcms06.png"),
          menuList: [
            { key: "compatibility", label: "信创适配" },
            { key: "gateway", label: "边缘网关" },
            { key: "advantage", label: "产品优势" },
            { key: "integration", label: "系统集成" },
            { key: "simulation", label: "解决方案" },
          ],
        },
        {
          key: "dataCenterInfrastructure",
          label: "数据中心基础设施管理DCIM",
          img: require("@/assets/scheme/dcim.jpg"),
          img01: require("@/assets/scheme/dcim01.jpg"),
          img02: require("@/assets/scheme/dcim02.jpg"),
          img03: require("@/assets/scheme/dcim03.jpg"),
          img04: require("@/assets/scheme/dcim04.jpg"),
          img05: require("@/assets/scheme/dcim05.jpg"),
          img06: require("@/assets/scheme/dcim06.jpg"),
          img07: require("@/assets/scheme/dcim07.jpg"),
          menuList: [
            { key: "architecture", label: "功能架构图" },
            { key: "dashboard", label: "数据驾驶舱" },
            { key: "efficiency", label: "能效管理" },
            { key: "capacity", label: "容量管理" },
            { key: "alarm", label: "告警管理" },
            { key: "report", label: "报表统计" },
            { key: "asset", label: "资产管理" },
          ],
        },
        {
          key: "dataCenterOperations",
          label: "数据中心运维管理DCOM",
          img: require("@/assets/scheme/dcom.png"),
          img01: require("@/assets/scheme/dcom01.png"),
          img02: require("@/assets/scheme/dcom02.png"),
          img03: require("@/assets/scheme/dcom03.png"),
          img04: require("@/assets/scheme/dcom04.png"),
          img05: require("@/assets/scheme/dcom05.png"),
          img06: require("@/assets/scheme/dcom06.png"),
          img07: require("@/assets/scheme/dcom07.png"),
          img08: require("@/assets/scheme/dcom08.png"),
          img09: require("@/assets/scheme/dcom09.png"),
          img10: require("@/assets/scheme/dcom10.png"),
          img11: require("@/assets/scheme/dcom11.png"),
          menuList: [
            { key: "architecture", label: "功能架构图" },
            { key: "process", label: "流程管理" },
            { key: "workorder", label: "工单管理" },
            { key: "maintenance", label: "接维管理" },
            { key: "inspection", label: "巡检管理" },
            { key: "knowledge", label: "知识库" },
            { key: "workspace", label: "工作台" },
            { key: "cost", label: "成本管理" },
            { key: "emergency", label: "应急管理" },
            { key: "ar", label: "AR巡检" },
            { key: "vrTraining", label: "VR培训" },
          ],
        },
        {
          key: "digitalPowerPlant",
          label: "数字电厂智能巡检解决方案",
          img: require("@/assets/scheme/digital.png"),
          img01: require("@/assets/scheme/digital01.png"),
          img02: require("@/assets/scheme/digital02.png"),
          img03: require("@/assets/scheme/digital03.png"),
          img04: require("@/assets/scheme/digital04.png"),
          img05: require("@/assets/scheme/digital05.png"),
          menuList: [
            { key: "solution", label: "解决方案" },
            { key: "factory", label: "数字电厂" },
            { key: "inspection", label: "智能巡检系统" },
            { key: "video", label: "视频分析平台" },
            { key: "danger", label: "危险源识别" },
          ],
        },
        {
          key: "chemicalIndustry",
          label: "危化行业智能巡检解决方案",
          img: require("@/assets/scheme/chemical.png"),
          img01: require("@/assets/scheme/chemical01.png"),
          img02: require("@/assets/scheme/chemical02.jpg"),
          img03: require("@/assets/scheme/chemical03.png"),
          menuList: [
            { key: "architecture", label: "功能架构图" },
            { key: "robot", label: "巡检机器人" },
            { key: "unmanned", label: "无人巡检" },
          ],
        },
        {
          key: "energyManagement",
          label: "光伏、储能EMS解决方案",
          img: require("@/assets/scheme/ems.png"),
          img01: require("@/assets/scheme/ems01.png"),
          img02: require("@/assets/scheme/ems02.png"),
          img03: require("@/assets/scheme/ems03.png"),
          menuList: [
            { key: "solution", label: "解决方案" },
            { key: "architecture", label: "系统架构" },
            { key: "operation", label: "系统运维" },
          ],
        },
        {
          key: "intelligentBuilding",
          label: "智能建筑管理平台解决方案",
          img: require("@/assets/scheme/intelligent.png"),
          img00: require("@/assets/scheme/intelligent01.png"),
          img01: require("@/assets/scheme/intelligent02.png"),
          img02: require("@/assets/scheme/intelligent03.png"),
          img03: require("@/assets/scheme/intelligent04.png"),
          img04: require("@/assets/scheme/intelligent05.png"),
          menuList: [
            { key: "architecture", label: "方案简介" },
            { key: "function", label: "核心功能亮点" },
            { key: "constructionPlan", label: "建设方案" },
            { key: "constructionPoint", label: "建设要点" },
          ],
        },
        {
          key: "aiEnergyManagement",
          label: "AI节能降碳平台",
          img: require("@/assets/scheme/ai.svg"),
          img01: require("@/assets/scheme/ai01.svg"),
          img02: require("@/assets/scheme/ai02.svg"),
          img03: require("@/assets/scheme/ai03.svg"),
          img04: require("@/assets/scheme/ai04.svg"),
          menuList: [
            { key: "solution", label: "应用场景" },
            { key: "architecture", label: "核心算法" },
            { key: "platform", label: "运维服务平台" },
          ],
        },
      ],
      activeItem: "",
      activeMenu: "",
      showBackToTop: false,
    };
  },
  computed: {
    currentNav() {
      return (
        this.navList.find((item) => item.key === this.activeItem) ||
        this.navList[0]
      );
    },
    currentExtraImages() {
      if (this.currentNav.key === "environmentalMonitoring") {
        return {
          images: [
            this.currentNav.img01,
            this.currentNav.img02,
            this.currentNav.img03,
            this.currentNav.img04,
            this.currentNav.img06,
          ].filter(Boolean),
          prefix: "img",
          altPrefix: "dcms0",
        };
      }
      if (this.currentNav.key === "dataCenterInfrastructure") {
        return {
          images: [
            this.currentNav.img01,
            this.currentNav.img02,
            this.currentNav.img03,
            this.currentNav.img04,
            this.currentNav.img05,
            this.currentNav.img06,
            this.currentNav.img07,
          ].filter(Boolean),
          prefix: "dcim",
          altPrefix: "dcim",
        };
      }
      if (this.currentNav.key === "dataCenterOperations") {
        return {
          images: [
            this.currentNav.img01,
            this.currentNav.img02,
            this.currentNav.img03,
            this.currentNav.img04,
            this.currentNav.img05,
            this.currentNav.img06,
            this.currentNav.img07,
            this.currentNav.img08,
            this.currentNav.img09,
            this.currentNav.img10,
            this.currentNav.img11,
          ].filter(Boolean),
          prefix: "dcom",
          altPrefix: "dcom",
        };
      }
      if (this.currentNav.key === "digitalPowerPlant") {
        return {
          images: [
            this.currentNav.img01,
            this.currentNav.img02,
            this.currentNav.img03,
            this.currentNav.img04,
            this.currentNav.img05,
          ].filter(Boolean),
          prefix: "digital",
          altPrefix: "digital",
        };
      }
      if (this.currentNav.key === "chemicalIndustry") {
        return {
          images: [
            this.currentNav.img01,
            this.currentNav.img02,
            this.currentNav.img03,
          ].filter(Boolean),
          prefix: "chemical",
          altPrefix: "chemical",
        };
      }
      if (this.currentNav.key === "energyManagement") {
        return {
          images: [
            this.currentNav.img01,
            this.currentNav.img02,
            this.currentNav.img03,
          ].filter(Boolean),
          prefix: "ems",
          altPrefix: "ems",
        };
      }
      if (this.currentNav.key === "intelligentBuilding") {
        return {
          images: [
            this.currentNav.img01,
            this.currentNav.img02,
            this.currentNav.img03,
            this.currentNav.img04,
            this.currentNav.img05,
          ].filter(Boolean),
          prefix: "intelligent",
          altPrefix: "intelligent",
        };
      }
      if (this.currentNav.key === "aiEnergyManagement") {
        return {
          images: [
            this.currentNav.img01,
            this.currentNav.img02,
            this.currentNav.img03,
            this.currentNav.img04,
          ].filter(Boolean),
          prefix: "ai",
          altPrefix: "ai",
        };
      }
      return { images: [], prefix: "", altPrefix: "" };
    },
  },
  watch: {
    "$route.query.key": {
      immediate: true,
      handler(key) {
        if (key && this.navList.some((item) => item.key === key)) {
          this.activeItem = key;
        } else {
          this.activeItem = this.navList[0].key;
        }
      },
    },
  },
  created() {
    const key = this.$route.query.key;
    if (key && this.navList.some((item) => item.key === key)) {
      this.activeItem = key;
    } else {
      this.activeItem = this.navList[0].key;
    }
  },
  methods: {
    handleMenuClick(key, idx) {
      console.log("key", key, idx, this.currentNav.key);

      this.activeMenu = key;
      if (
        this.currentNav.key === "environmentalMonitoring" &&
        typeof idx === "number"
      ) {
        nextTick(() => {
          const imgEl = document.getElementById("img" + (idx + 1));
          if (imgEl)
            imgEl.scrollIntoView({ behavior: "smooth", block: "center" });
        });
      }
      if (
        this.currentNav.key === "dataCenterInfrastructure" &&
        typeof idx === "number"
      ) {
        nextTick(() => {
          const imgEl = document.getElementById("dcim" + (idx + 1));
          if (imgEl)
            imgEl.scrollIntoView({ behavior: "smooth", block: "center" });
        });
      }
      if (
        this.currentNav.key === "dataCenterOperations" &&
        typeof idx === "number"
      ) {
        nextTick(() => {
          const imgEl = document.getElementById("dcom" + (idx + 1));
          if (imgEl)
            imgEl.scrollIntoView({ behavior: "smooth", block: "center" });
        });
      }
      if (
        this.currentNav.key === "digitalPowerPlant" &&
        typeof idx === "number"
      ) {
        nextTick(() => {
          const imgEl = document.getElementById("digital" + (idx + 1));
          if (imgEl)
            imgEl.scrollIntoView({ behavior: "smooth", block: "center" });
        });
      }
      if (
        this.currentNav.key === "chemicalIndustry" &&
        typeof idx === "number"
      ) {
        nextTick(() => {
          const imgEl = document.getElementById("chemical" + (idx + 1));
          if (imgEl)
            imgEl.scrollIntoView({ behavior: "smooth", block: "center" });
        });
      }
      if (
        this.currentNav.key === "energyManagement" &&
        typeof idx === "number"
      ) {
        nextTick(() => {
          const imgEl = document.getElementById("ems" + (idx + 1));
          if (imgEl)
            imgEl.scrollIntoView({ behavior: "smooth", block: "center" });
        });
      }
      if (
        this.currentNav.key === "intelligentBuilding" &&
        typeof idx === "number"
      ) {
        nextTick(() => {
          const imgEl = document.getElementById("intelligent" + (idx + 1));
          if (imgEl)
            imgEl.scrollIntoView({ behavior: "smooth", block: "center" });
        });
      }
      if (
        this.currentNav.key === "aiEnergyManagement" &&
        typeof idx === "number"
      ) {
        nextTick(() => {
          const imgEl = document.getElementById("ai" + (idx + 1));
          if (imgEl)
            imgEl.scrollIntoView({ behavior: "smooth", block: "center" });
        });
      }
    },
    handleNavClick(key) {
      this.activeItem = key;
      const nav = this.navList.find((item) => item.key === key);
      if (nav && nav.menuList && nav.menuList.length > 0) {
        // this.activeMenu = nav.menuList[0].key;
        this.activeMenu = "";
      } else {
        this.activeMenu = "";
      }
    },
    handleScroll() {
      this.showBackToTop = window.scrollY > 100;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    window.scrollTo(0, 0);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped>
.sidebar {
  position: fixed;
  left: 0;
  top: 20%;
  width: 160px;
  z-index: 1000;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.logo {
  width: 146px;
  height: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
}
.side-menu {
  width: 154px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.05);
}
.menu-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.menu-item {
  padding: 10px 0;
  text-align: center;
  color: #5f656c;
  font-size: 24px;
  cursor: pointer;
  border-radius: 6px;
  transition: color 0.2s, background 0.2s;
}
.menu-item.active {
  color: #257bff;
  background: #f5faff;
  font-weight: bold;
}

.scheme-container {
  width: 1374px;
  margin: 0 auto;
  padding: 20px;

  .nav-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: flex-start;
  }

  .nav-item {
    width: 437px;
    height: 72px;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    cursor: pointer;
    font-size: 16px;
    color: #333;
    transition: border 0.2s, box-shadow 0.2s;
  }
  .nav-item:hover {
    border: 2px solid #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }
  .nav-item.active {
    background: url("~@/assets/scheme/tab_active_bg.png") no-repeat center/cover;
    span {
      font-size: 20px;
      font-family: Microsoft YaHei, Microsoft YaHei-400;
      font-weight: 400;
      text-align: LEFT;
      color: #2c3239;
      line-height: 20px;
    }
  }
  .nav-item span {
    font-size: 20px;
    font-family: Microsoft YaHei, Microsoft YaHei-400;
    font-weight: 400;
    text-align: LEFT;
    color: #5f656c;
    line-height: 20px;
  }
}

.back-to-top {
  position: fixed;
  right: 32px;
  bottom: 32px;
  z-index: 9999;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #257bff;
  color: #fff;
  border: none;
  font-size: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  transition: box-shadow 0.2s;
}
.back-to-top:hover {
  background: #0056d6;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.22);
}
.fade-bottom-enter-active,
.fade-bottom-leave-active {
  transition: opacity 0.4s, transform 0.4s;
}
.fade-bottom-enter-from,
.fade-bottom-leave-to {
  opacity: 0;
  transform: translateY(40px) scale(0.9);
}
.fade-bottom-enter-to,
.fade-bottom-leave-from {
  opacity: 1;
  transform: translateY(0) scale(1);
}
</style>
